// Add types!
export default function isTabbing() {

  function handleFirstTab(e) {
    if (e.keyCode === 9) {
      document.documentElement.classList.add('mdn-isTabbing');

      window.removeEventListener('keydown', handleFirstTab);
      window.addEventListener('mousedown', handleMouseDownOnce);

      // console.log('isTabbing is running');
    }
  }

  function handleMouseDownOnce() {
    document.documentElement.classList.remove('mdn-isTabbing');

    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);

    // console.log('isTabbing is off');
  }

  window.addEventListener('keydown', handleFirstTab);


  }

  export {
    isTabbing
  }
